import {
  MmmModelOutput,
  MarketingSourceCategoryForecast
} from '../mmmModelOutput';
import {
  AxisChartByString,
  ChartDataType,
  ChartDisplayType,
  DataPointSetByString
} from 'features/charts/chart.models';
import { v4 as guid } from 'uuid';
import { toMillion } from '../charts/mmm-chart-helpers';

// ALL THIS NEEDS CHANGING AS IT WAS COPY PASTA
export const createmodelledRoiGroupedChart = (
  ddaData: MmmModelOutput
): AxisChartByString => {
  const dataPointStrings = ddaData.forecasts.map(
    (forecast) => forecast.sourceCategoryDisplayName
  );

  const spendDataSets = createSpendDataSets(
    ddaData.forecasts,
    dataPointStrings
  );

  const revenueDataSets = createRevenueDataSets(
    ddaData.forecasts,
    dataPointStrings
  );

  const barDataPointSets = [...spendDataSets, ...revenueDataSets];
  const yHighestValue = barDataPointSets.reduce(
    (highestValue, currentValue) =>
      currentValue.value > highestValue ? currentValue.value : highestValue,
    0
  );

  const chart: AxisChartByString = {
    id: guid(),
    type: ChartDataType.STRING,
    title: '',
    dataPointSets: barDataPointSets,
    yAxisFormat: new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      maximumSignificantDigits: 1,
      notation: 'compact'
    }),
    tooltipFormat: new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      maximumSignificantDigits: 3,
      notation: 'compact'
    }),
    xAxisTitle: '',
    yAxisTitle: 'Spend',
    yHighestValue,
    defaultChartDisplayType: ChartDisplayType.DOUGHNUT,
    shouldAnimate: true,
    shouldShowChartTypeDropdown: false
  };

  return chart;
};

function createSpendDataSets(
  forecasts: MarketingSourceCategoryForecast[],
  dataPointStrings: string[]
): DataPointSetByString[] {
  const dataSets = dataPointStrings.map((dataPointString) => {
    const spend =
      forecasts.find(
        (forecast) => forecast.sourceCategoryDisplayName === dataPointString
      )?.spend ?? 0;

    const dataPointSet: DataPointSetByString = {
      dataPointString,
      dataPointSetName: 'Spend',
      value: toMillion(spend)
    };

    return dataPointSet;
  });

  return dataSets;
}

function createRevenueDataSets(
  forecasts: MarketingSourceCategoryForecast[],
  dataPointStrings: string[]
): DataPointSetByString[] {
  const dataSets = dataPointStrings.map((dataPointString) => {
    const revenue =
      forecasts.find(
        (forecast) => forecast.sourceCategoryDisplayName === dataPointString
      )?.revenue ?? 0;

    const dataPointSet: DataPointSetByString = {
      dataPointString,
      dataPointSetName: 'Revenue',
      value: toMillion(revenue)
    };

    return dataPointSet;
  });

  return dataSets;
}
